import { createFeatureSelector, createSelector } from '@ngrx/store';
import { firebaseFeatureKey, IFirebaseState } from './firebase-state.reducer';

export const selectNewsState = createFeatureSelector<IFirebaseState>(firebaseFeatureKey);
export const selectFirebaseUser = createSelector(
  selectNewsState,
  (yFirebaseState) => yFirebaseState.user
);
